/* gk-coupon */
if (!customElements.get('gk-coupon')) {
  class GkCoupon extends HTMLElement {
    connectedCallback() {
      this.code = this.dataset.code || '';
      this.copyLabel = this.dataset.copyLabel || 'COPIAR';
      this.copiedLabel = this.dataset.copiedLabel || 'COPIADO!';
      this.button = this.querySelector('[data-gkc-copy]');
      this.btnText = this.querySelector('[data-gkc-text]');
      this.setupLayout();
      if (!this.button) return;
      this.button.addEventListener('click', () => this.copy());
    }

    // Cartao do cupao: titulo + selo da percentagem, frase curta, e linha com o codigo + botao COPIAR
    setupLayout() {
      if (this.classList.contains('gkc--v3')) return;
      this.classList.add('gkc--v3');
      const badge = this.querySelector('.gkc__badge');
      const code = this.querySelector('.gkc__code');
      const badgeText = badge ? badge.textContent.trim() : '';
      const pctMatch = badgeText.match(/\d+\s*%/);
      const pct = pctMatch ? pctMatch[0].replace(/\s+/g, '') : '';

      const head = document.createElement('div');
      head.className = 'gkc__head';
      head.innerHTML =
        '<span class="gkc__ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.2" fill="currentColor"/></svg></span>' +
        '<span class="gkc__title">CUPÃO EXCLUSIVO</span>';
      const pill = document.createElement('span');
      pill.className = 'gkc__pill';
      pill.textContent = pct ? pct + ' EXTRA' : badgeText;
      head.appendChild(pill);

      const desc = document.createElement('p');
      desc.className = 'gkc__desc';
      desc.textContent = pct
        ? 'Usa no checkout e ganha mais ' + pct + ' de desconto.'
        : 'Usa no checkout para ganhar o desconto extra.';

      const row = document.createElement('div');
      row.className = 'gkc__row';
      if (code) row.appendChild(code);
      if (this.button) row.appendChild(this.button);

      this.insertBefore(head, this.firstChild);
      this.insertBefore(desc, head.nextSibling);
      this.insertBefore(row, desc.nextSibling);
    }

    async copy() {
      const txt = this.code;
      if (!txt) return;
      let ok = false;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(txt);
          ok = true;
        } else {
          const ta = document.createElement('textarea');
          ta.value = txt;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          ok = true;
        }
      } catch (e) {
        ok = false;
      }

      if (ok) this.flashCopied();
    }

    flashCopied() {
      this.classList.add('is-copied');
      if (this.btnText) this.btnText.textContent = this.copiedLabel;
      clearTimeout(this._t);
      this._t = setTimeout(() => {
        this.classList.remove('is-copied');
        if (this.btnText) this.btnText.textContent = this.copyLabel;
      }, 1800);
    }
  }
  customElements.define('gk-coupon', GkCoupon);
}
